module.exports = __webpack_public_path__ + "assets/conquest.ec940ab4.svg";